"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardRenderItemComponent_vue_1 = require("@/client/components/card/CardRenderItemComponent.vue");
const CardRenderItemType_1 = require("@/common/cards/render/CardRenderItemType");
const CardResource_1 = require("@/common/CardResource");
const Size_1 = require("@/common/cards/render/Size");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardVictoryPoints',
    props: {
        victoryPoints: {
            type: [Number, Object],
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_vue_1.default,
    },
    computed: {
        classes() {
            if (typeof this.victoryPoints === 'number') {
                return '';
            }
            else {
                const classes = ['card-points'];
                if (this.victoryPoints.vermin) {
                    classes.push('card-points-normal');
                    classes.push('card-points-vermin');
                    classes.push('red-outline');
                }
                else if (this.victoryPoints.anyPlayer) {
                    classes.push('card-points-big');
                    classes.push('red-outline');
                }
                else {
                    classes.push('card-points-normal');
                }
                return classes.join(' ');
            }
        },
        points() {
            if (typeof this.victoryPoints === 'number') {
                return '';
            }
            const vps = this.victoryPoints;
            if (vps.item === undefined && vps.points === 0 && vps.target === 0) {
                return '?';
            }
            if (vps.item === undefined) {
                return `${vps.points}`;
            }
            if (vps.target === vps.points || vps.target === 1) {
                return `${vps.points}/`;
            }
            if (vps.asFraction) {
                if (vps.target === 3 && vps.points === 1) {
                    return '⅓';
                }
            }
            return `${vps.points}/${vps.target}`;
        },
        animal() {
            return { is: 'item', type: CardRenderItemType_1.CardRenderItemType.RESOURCE, resource: CardResource_1.CardResource.ANIMAL, size: Size_1.Size.SMALL, amount: 1 };
        },
        city() {
            return { is: 'item', type: CardRenderItemType_1.CardRenderItemType.CITY, size: Size_1.Size.SMALL, amount: 1 };
        },
    },
});
